var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 512 512" }, props),
    React.createElement("path", { d: "M218 105c11-11 11-29 0-40s-29-11-40 0L8 235c-11 11-11 29 0 40l171 172c11 11 29 11 40 0s11-29 0-40L69 255zm75 302c-11 11-11 29 0 40s29 11 40 0l171-172c11-11 11-29 0-40L334 65c-11-11-29-11-40 0s-11 29 0 40l149 150z" })
  );
});